import styled from '@emotion/styled';
import { Flex } from '@pairy/pds-react';

export const FlexWrapper = styled(Flex)`
  overflow-y: scroll;
`;
